import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import styles from './settings-drawer.module.css';

export interface TabButtonRowItem<T extends string> {
  key: T;
  label: string;
  icon?: IconDefinition;
}

export default function TabButtonRow<T extends string>({
  items,
  activeKey,
  onSelect,
  orientation,
  compact,
}: {
  items: TabButtonRowItem<T>[];
  activeKey: T;
  onSelect: (key: T) => void;
  orientation: 'horizontal' | 'vertical';
  compact?: boolean; // icon-only, no label — used by settings-drawer on mobile
}) {
  if (orientation === 'horizontal') {
    return (
      <div className={styles.tabBar}>
        {items.map(item => (
          <button
            key={item.key}
            type="button"
            className={`${styles.tabButton} ${activeKey === item.key ? styles.tabButtonActive : ''}`}
            onClick={() => onSelect(item.key)}
            title={item.label}
          >
            {item.icon && <FontAwesomeIcon icon={item.icon} className={compact ? '' : 'me-2'} />}
            {!compact && item.label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div
      className="d-flex flex-column p-3 flex-shrink-0"
      style={{ width: 180, background: 'var(--bs-primary-200)', gap: 12 }}
    >
      {items.map(item => (
        <button
          key={item.key}
          type="button"
          className={`btn btn-sm text-start border-0 bg-transparent p-0${activeKey === item.key ? '' : ' mutedText'}`}
          onClick={() => onSelect(item.key)}
          style={{
            fontWeight: activeKey === item.key ? 700 : 400,
            fontSize: 16,
            padding: '6px 0',
          }}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}
